<template>
  <div :class="{ hidden: hiddenPlaceholder || modelValue }" class="textarea">
    <p class="textarea-up-holder">{{ placeholder }}</p>
    <p
      v-if="limit"
      class="textarea-limit"
      :class="{ 'error-color': modelValue.length > limit }"
    >
      {{ modelValue.length }} / {{ limit }}
    </p>
    <textarea
      @keypress.enter="$emit('enter')"
      @input="
        $emit('clear-error'), $emit('update:modelValue', $event.target.value)
      "
      @focus="hiddenPlaceholder = true"
      @blur="hiddenPlaceholder = false"
      :value="modelValue"
      :class="{ 'textarea-error': error }"
      :placeholder="hiddenPlaceholder ? '' : placeholder"
      :rows="rows || 2"
    ></textarea>
    <transition name="fade">
      <div v-if="error" class="error">
        {{ error }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    error: {
      type: String,
    },
    rows: {
      type: Number,
    },
    limit: {
      type: Number,
    },
  },
  data() {
    return {
      hiddenPlaceholder: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.textarea {
  background: $white;
  border: 1px solid $white;
  box-sizing: border-box;
  width: 100%;
  height: 68px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.3s;
  &-up-holder {
    font-weight: 500;
    font-size: 10px;
    line-height: 140%;
    position: absolute;
    opacity: 0;
    color: $input-grey;
    z-index: -1;
  }
  &-limit {
    font-weight: 500;
    font-size: 10px;
    line-height: 140%;
    position: absolute;
    color: $input-grey;
    top: 4px;
    right: 10px;
  }
  &.hidden {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .textarea-up-holder {
      opacity: 0.8;
      position: relative;
      z-index: 0;
    }
    textarea {
      padding: 0;
    }
  }
  &:hover {
    border: 1px solid $gold;
  }
  &:hover textarea::placeholder {
    color: $black-main;
  }
  @include mobile {
    width: 100%;
  }
  textarea {
    font-size: 14px;
    width: 100%;
    padding: 14px 0;
    @include mobile {
      font-size: 16px;
    }
    &::placeholder {
      transition: all 0.3s;
    }
    &::placeholder {
      color: $input-placeholder-grey;
    }
    &.textarea-error {
      color: $input-error;
    }
  }
  .error-color {
    color: $input-error;
  }
  .error {
    font-size: 12px;
    position: absolute;
    color: $input-error;
    left: 0;
    bottom: -17px;
  }
}
</style>
